import React, { useEffect, useState } from 'react';
import './style.sass';
import { Link, useHistory, useParams } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer'
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito'
import { MenuCredito } from 'components/menuCredito'
import { ModalError } from 'components/Error/ErrorModal'
import { DataCard, DataCardUpdate } from 'pages/Credito/2-AgregarTarjeta/AgregarTarjetaBancaria/DataCard'
import { DirectionCard } from 'pages/Credito/2-AgregarTarjeta/AgregarTarjetaBancaria/DirectionCard'
import { encodeStorage, decodeStorage } from 'functions/storageBase64'
import { getDataCardT1, postAddCardT1, updateCardT1 } from 'services/T1Pagos'
import { useIsMobile } from 'hooks/useIsMobile'
import { usePayCard } from 'hooks/usePayCard'
import Loading from 'components/Loading'
import { Error500 } from 'components/Error/Error500';

export default function AgregarTarjetaBancaria() {

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Add Credit Card  Credit-Page')
        window.ineum('meta', 'portal', 'Credito')
    }, [])

    const clientT1 = decodeStorage('clientT1')
    const { isMobile } = useIsMobile()
    const [loading, setLoading] = useState(false)
    const { dataPayment, successPay, errorPay } = usePayCard()

    const [titlePage, setTitlePage] = useState()
    const [stepPage, setStepPage] = useState(1)
    const [addCard, setAddCard] = useState({
        cardNumber: "",
        titular: "",
        mes: "",
        anio: "",
        cvc: ""
    })
    const [addDirection, setAddDirection] = useState({
        calle: "",
        numExt: "",
        numInt: "",
        cp: "",
        estado: "",
        municipio: "",
        ciudad: "",
        colonia: ""
    })

    const history = useHistory();
    const payCardRelation = decodeStorage('payCardRelation')

    useEffect(() => {
        if (!payCardRelation) {
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar/pagar-tarjeta`);
        }
    }, [])

    useEffect(() => {
        setTitlePage('Agregar tarjeta')
        setStepPage(1)
    }, [])

    const [sectionPay, setSectionPay] = useState(false)
    const [responseAddCardT1, setResponseAddCardT1] = useState()
    useEffect(() => {
        if (sectionPay) {
            let addCardT1 = {
                nombre: addCard.titular,
                pan: Number(addCard.cardNumber),
                cvv2: String(addCard.cvc),
                expiracion_mes: parseInt(addCard.mes),
                expiracion_anio: parseInt(addCard.anio),
                direccion: {
                    linea1: String(addDirection.calle).slice(0, 120),
                    linea2: String(addDirection.numExt + ',' + addDirection.numInt).slice(0, 120),
                    linea3: String(addDirection.colonia).slice(0, 120),
                    cp: String(addDirection.cp),
                    municipio: String(addDirection.municipio),
                    ciudad: String(addDirection.ciudad),
                    estado: String(addDirection.estado),
                    pais: "MEX",
                    referencia_1: "",
                    referencia_2: "",
                    longitud: Number(-90),
                    latitud: Number(-90)
                },
                cliente_id: String(clientT1.id),
                default: true,
                cargo_unico: false
            }
            //console.log('addCardT1: ',addCardT1)
            postAddCardT1(addCardT1)
                .then(setResponseAddCardT1)
        }
    }, [sectionPay])

    const [errorCode, setErrorCode] = useState()
    const [messageResponse, setMessageResponse] = useState()
    const [sectionActive, setSectionActive] = useState(null)
    const [showModalErr, setShowModalErr] = useState(false);
    useEffect(() => {
        if (responseAddCardT1) {
            setSectionPay(false)
            if (responseAddCardT1.statusCode === 200) {
                //console.log('responseAddCardT1', responseAddCardT1.data)
                dataPayment({
                    idCard: responseAddCardT1?.data?.tarjeta?.token,
                    cvv: parseInt(addCard.cvc),
                    payCardRelation: payCardRelation,
                    addCard: responseAddCardT1
                })
            } else if (responseAddCardT1.statusCode === 400) {
                let dataError = JSON.parse(responseAddCardT1.data)
                setLoading(false)
                if (dataError) {
                    //console.log(dataError)
                    //console.log(dataError?.data?.errors?.pan[0])
                    setShowModalErr(true)
                    setSectionActive(null)
                    setErrorCode({ codMen: dataError?.error?.code })
                    setMessageResponse(dataError?.data?.errors?.pan[0])
                }
            }
            else if (responseAddCardT1.statusCode === 409) {
                let dataError = JSON.parse(responseAddCardT1.data)
                setLoading(false)
                if (dataError) {
                    //console.log(dataError)
                    //console.log(dataError?.data?.errors?.pan[0])
                    setShowModalErr(true)
                    setSectionActive(null)
                    setErrorCode({ codMen: dataError?.error?.code })
                    setMessageResponse(dataError?.error?.message)
                }
            }
        }
    }, [responseAddCardT1])


    // valida pago y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'choiseCards') {
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar/elegir-tarjeta`)
        }
    }
    useEffect(() => {
        if (successPay) {
            setLoading(false)
            encodeStorage('payCodeSuccess', successPay)
            history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/thankYouPage`);
        }
        else if (errorPay) {
            setLoading(false)
            setShowModalErr(true)
            setErrorCode(errorPay)
            setSectionActive('choiseCards')
            setMessageResponse(errorPay?.message)
        }
    }, [successPay, errorPay])


    const clickBackButton = () => {
        if (stepPage === 1) {
            history.goBack(-1)
        }
        else if (stepPage === 2) {
            setTitlePage('Agregar tarjeta')
            setStepPage(1)
        }
    }

    const nextPage = () => {
        setTitlePage('Dirección de la tarjeta')
        setStepPage(2)
    }

    const paySection = () => {
        setLoading(true)
        setSectionPay(true)
    }

    return (
        <>
            {loading && <Loading />}
            {isMobile
                ? isMobile === 'desktop'
                    ? <Header type="complete" />
                    : <HeaderMobileCredito title={titlePage} type="backFullAction" action={clickBackButton} />
                : null
            }

            <div className={isMobile === 'desktop' ? "container" : null}>
                <div className="contPlanPayments">
                    <MenuCredito />
                    {errorCode >= 500
                        ? <Error500 />
                        : <div className="contPlanes">

                            {stepPage === 1 &&
                                <DataCard
                                    setAddCard={setAddCard}
                                    addCard={addCard}
                                    nextPage={nextPage}
                                />
                            }
                            {stepPage === 2 &&
                                <DirectionCard
                                    setAddDirection={setAddDirection}
                                    addDirection={addDirection}
                                    nextPage={paySection}
                                    action={clickBackButton}
                                    setLoading={setLoading}
                                />
                            }
                        </div>
                    }
                </div>
            </div>

            {showModalErr &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }

            {isMobile
                ? isMobile === 'desktop'
                    ? <Footer type="complete"/>
                    : null
                : null
            }
        </>
    )
}


export function EditarTarjetaBancaria() {
    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Edit Credit Card  Credit-Page')
        window.ineum('meta', 'portal', 'Credito')
    }, [])

    const params = useParams();


    const clientT1 = decodeStorage('clientT1')
    const { isMobile } = useIsMobile()
    const [loading, setLoading] = useState(false)

    const [titlePage, setTitlePage] = useState()
    const [stepPage, setStepPage] = useState(1)
    const [addCard, setAddCard] = useState({
        cardNumber: "",
        titular: "",
        mes: "",
        anio: "",
        cvc: ""
    })

    const history = useHistory();
    const payCardRelation = decodeStorage('payCardRelation')

    const [cardT1, setCardT1] = useState(false)
    useEffect(() => {
        if(params?.id){
            getDataCardT1(params?.id)
            .then(setCardT1)
        }
    }, [params])

    useEffect(() => {
        if(cardT1?.data?.data?.tarjeta){
            // console.log('cardT1: ', cardT1?.data?.data?.tarjeta)
            setAddCard({
                cardNumber: cardT1?.data?.data?.tarjeta?.pan,
                titular: cardT1?.data?.data?.tarjeta?.nombre,
                mes: cardT1?.data?.data?.tarjeta?.expiracion_mes,
                anio: cardT1?.data?.data?.tarjeta?.expiracion_anio
            })
        }
    }, [cardT1])

    useEffect(() => {
        //console.log('addCard: ', addCard)
    }, [addCard])


    useEffect(() => {
        setTitlePage('Editar tarjeta')
        setStepPage(1)
    }, [])

    const [sectionPay, setSectionPay] = useState(false)
    const [responseUpdateCardT1, setResponseUpdateCardT1] = useState()
    useEffect(() => {
        if (sectionPay) {
            let addCardT1 = {
                nombre: addCard.titular,
                expiracion_mes: parseInt(addCard.mes),
                expiracion_anio: parseInt(addCard.anio)
            }
            //console.log({dataRaw: addCardT1, idCard: params.id })
            updateCardT1({dataRaw: addCardT1, idCard: params.id })
            .then(setResponseUpdateCardT1)
        }
    }, [sectionPay])

    useEffect(() => {
        if (responseUpdateCardT1) {
            setSectionPay(false)
            if (responseUpdateCardT1.statusCode === 200) {
                //console.log('responseUpdateCardT1', responseUpdateCardT1.data)
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar/elegir-tarjeta`)
            } else if (responseUpdateCardT1.statusCode === 400) {
                let dataError = JSON.parse(responseUpdateCardT1.data)
                setLoading(false)
                if (dataError) {
                    //console.log(dataError)
                    //console.log(dataError?.data?.errors?.pan[0])
                    setShowModalErr(true)
                    setSectionActive(null)
                    setErrorCode({ codMen: dataError?.error?.code })
                    setMessageResponse(dataError?.data?.errors?.pan[0])
                }
            }
            else if (responseUpdateCardT1.statusCode === 409) {
                let dataError = JSON.parse(responseUpdateCardT1.data)
                setLoading(false)
                if (dataError) {
                    setShowModalErr(true)
                    setSectionActive(null)
                    setErrorCode({ codMen: dataError?.error?.code })
                    setMessageResponse(dataError?.error?.message)
                }
            }
        }
    }, [responseUpdateCardT1])

    const [errorCode, setErrorCode] = useState()
    const [messageResponse, setMessageResponse] = useState()
    const [sectionActive, setSectionActive] = useState(null)
    const [showModalErr, setShowModalErr] = useState(false);

    // valida pago y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'choiseCards') {
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar/elegir-tarjeta`)
        }
    }

    const clickBackButton = () => {
        if (stepPage === 1) {
            history.goBack(-1)
        }
        else if (stepPage === 2) {
            setTitlePage('Editar tarjeta')
            setStepPage(1)
        }
    }


    const paySection = () => {
        setLoading(true)
        setSectionPay(true)
    }


    return (
        <>
            {loading && <Loading />}
            {isMobile
                ? isMobile === 'desktop'
                    ? <Header type="complete" />
                    : <HeaderMobileCredito title={titlePage} type="backFullAction" action={clickBackButton} />
                : null
            }

            <div className={isMobile === 'desktop' ? "container" : null}>
                <div className="contPlanPayments update">
                    <MenuCredito />
                    {errorCode >= 500
                        ? <Error500 />
                        : <div className="contPlanes">
                            <DataCardUpdate
                                setAddCard={setAddCard}
                                addCard={addCard}
                                nextPage={paySection}
                            />
                        </div>
                    }
                </div>
            </div>

            {showModalErr &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }

            {isMobile
                ? isMobile === 'desktop'
                    ? <Footer type="complete"/>
                    : null
                : null
            }
        </>
    )
}